// import React, { useState, useEffect } from 'react'; // Import React and hooks for state management and lifecycle methods
// import { AppBar, Toolbar, IconButton, Typography, Box, Tooltip, Avatar, Menu, MenuItem, Container } from '@mui/material'; // Import Material-UI components for UI styling and layout
// import { Link, useNavigate } from 'react-router-dom'; // Import React Router components for navigation and links
// import { onAuthStateChanged, signOut } from 'firebase/auth'; // Import Firebase auth methods to track auth state and sign out users
// import { auth } from './firebase'; // Import the configured Firebase authentication instance

// const settings = ['Login']; // Define menu settings, used in the user menu dropdown (will change to "Logout" if the user is logged in)

// function Navbar() {
//   // State to manage the anchor element for the user menu (for positioning)
//   const [anchorElUser, setAnchorElUser] = useState(null);
//   // State to track if a user is currently logged in
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   // State to determine if the current user is an admin
//   const [isAdmin, setIsAdmin] = useState(false);
//   // State to store user data such as display name and email
//   const [userData, setUserData] = useState({});
//   const navigate = useNavigate(); // Hook to programmatically navigate between pages

//   useEffect(() => {
//     // Set up an authentication state observer and retrieve user data on state change
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         const { displayName, email } = user; // Destructure user properties to get display name and email
//         setUserData({ displayName, email }); // Set user data in the state
//         setIsLoggedIn(true); // Set logged-in status to true
//         // Check if the logged-in user is an admin by matching their email with a predefined list in environment variables
//         setIsAdmin(
//           [process.env.REACT_APP_ADMIN_EMAIL1, process.env.REACT_APP_ADMIN_EMAIL2, process.env.REACT_APP_ADMIN_EMAIL3, process.env.REACT_APP_ADMIN_EMAIL4].includes(email)
//         );

//         // Navigate based on role (Admin or Normal User) after login
//         if ([process.env.REACT_APP_ADMIN_EMAIL1, process.env.REACT_APP_ADMIN_EMAIL2, process.env.REACT_APP_ADMIN_EMAIL3, process.env.REACT_APP_ADMIN_EMAIL4].includes(email)) {
//           navigate('/UploadEvent'); // Navigate to UploadEvent page for Admin
//         } else {
//           navigate('/home'); // Navigate to Home page for normal users
//         }
//       } else {
//         setIsLoggedIn(false); // Set logged-in status to false if no user is logged in
//         setIsAdmin(false); // Set admin status to false
//       }
//     });

//     // Cleanup function to unsubscribe from the listener when the component unmounts
//     return () => unsubscribe();
//   }, [navigate]); // Dependency array includes navigate, ensuring the effect is re-run if the navigate reference changes

//   // Handle the event of opening the user menu by setting the anchor element
//   const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
//   // Close the user menu by setting the anchor element to null
//   const handleCloseUserMenu = () => setAnchorElUser(null);

//   // Function to handle login or logout based on the current authentication state
//   const handleLoginLogout = () => {
//     if (isLoggedIn) {
//       signOut(auth) // Firebase function to log out the user
//         .then(() => {
//           setUserData({}); // Clear user data on successful logout
//           setIsLoggedIn(false); // Update the logged-in state
//           navigate('/home'); // Redirect to home page after logout
//         })
//         .catch(console.error); // Log any errors that occur during the sign-out process
//     } else {
//       navigate('/login'); // Redirect to the login page if the user is not logged in
//     }
//   };

//   return (
//     <>
//       <AppBar position="static"> {/* Define a static AppBar at the top of the page */}
//         <Container maxWidth="xl"> {/* Container to control the width of the AppBar */}
//           <Toolbar disableGutters> {/* Toolbar to arrange content horizontally */}
//             {/* Rete Logo */}
//             <img src="/ov--new.png" alt="Rete Logo" style={{ height: 70, marginRight: 10 }} />
//             {/* Application Title */}
//             <Typography
//               variant="h6"
//               noWrap
//               component={Link} // Link component from React Router to handle navigation
//               to="/" // Navigate to home page when clicked
//               sx={{
//                 mr: 2,
//                 fontFamily: 'monospace',
//                 fontWeight: 700,
//                 letterSpacing: '.1rem',
//                 color: 'inherit',
//                 textDecoration: 'none',
//               }}
//             >
//               Events
//             </Typography>
//             <Box sx={{ flexGrow: 1 }} /> {/* Empty box to push menu items to the right */}

//             <Box sx={{ mr: 2 }}> {/* Box for styling the user avatar and menu */}
//               <Tooltip title="Open settings"> {/* Tooltip on the Avatar */}
//                 <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}> {/* Button to open user menu */}
//                   {/* Display user avatar or default avatar */}
//                   <Avatar alt={userData.displayName} src="/static/images/avatar/2.jpg" />
//                 </IconButton>
//               </Tooltip>
//               {/* User menu for login/logout */}
//               <Menu
//                 sx={{ mt: '45px' }} // Style for menu margin-top
//                 id="menu-appbar"
//                 anchorEl={anchorElUser} // Bind the menu to the anchor element
//                 anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Define where the menu originates from
//                 keepMounted // Keep the menu mounted even when closed
//                 transformOrigin={{ vertical: 'top', horizontal: 'right' }} // Define where the menu transforms from
//                 open={Boolean(anchorElUser)} // Open the menu when anchorElUser is not null
//                 onClose={handleCloseUserMenu} // Close the menu when requested
//               >
//                 {/* Map through the settings array and render each setting in the menu */}
//                 {settings.map((setting, index) => (
//                   <MenuItem key={index} onClick={handleLoginLogout}> {/* Call handleLoginLogout on click */}
//                     {/* Display 'Login' or 'Logout' based on current user state */}
//                     <Typography textAlign="center">{isLoggedIn ? 'Logout' : 'Login'}</Typography>
//                   </MenuItem>
//                 ))}
//               </Menu>
//             </Box>
//           </Toolbar>
//         </Container>
//       </AppBar>
//     </>
//   );
// }

// export default Navbar;






// import React, { useState, useEffect } from 'react';
// import { AppBar, Toolbar, IconButton, Typography, Box, Tooltip, Avatar, Menu, MenuItem, Container } from '@mui/material';
// import { Link, useNavigate } from 'react-router-dom';
// import { onAuthStateChanged, signOut } from 'firebase/auth';
// import { auth } from './firebase';

// const settings = ['Login']; // Menu options

// function Navbar() {
//   const [anchorElUser, setAnchorElUser] = useState(null);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [isAdmin, setIsAdmin] = useState(false);
//   const [userData, setUserData] = useState({});
//   const navigate = useNavigate();

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (user) => {
//       if (user) {
//         const { displayName, email } = user;
//         setUserData({ displayName, email });
//         setIsLoggedIn(true);
  
//         // Retrieve JWT token from session storage
//         const jwtToken = sessionStorage.getItem('jwtToken');
//         console.log('JWT Token retrieved:', jwtToken); // Check if JWT token is retrieved
  
//         // Decode the token to check user details
//         if (jwtToken) {
//           try {
//             const response = await fetch('https://user-management-api-latest.onrender.com/api/protected/user-details', {
//               method: 'GET',
//               headers: {
//                 'Authorization': `Bearer ${jwtToken}`,
//               },
//             });
  
//             if (response.ok) {
//               const decodedData = await response.json();
//               console.log('Decoded user data:', decodedData); // Check decoded user data
  
//               // Check if the decoded email matches admin emails
//               const isAdminEmail = [
//                 process.env.REACT_APP_ADMIN_EMAIL1,
//                 process.env.REACT_APP_ADMIN_EMAIL2,
//                 process.env.REACT_APP_ADMIN_EMAIL3,
//                 process.env.REACT_APP_ADMIN_EMAIL4,
//               ].includes(decodedData.email);
//               console.log('Is admin:', isAdminEmail); // Check if user is admin
  
//               setIsAdmin(isAdminEmail);
  
//               // Navigate based on user role
//               if (isAdminEmail) {
//                 console.log('Navigating to UploadEvent page'); // Log navigation for admin
//                 navigate('/UploadEvent'); // Navigate to UploadEvent page for Admin
//               } else {
//                 console.log('Navigating to home page'); // Log navigation for normal user
//                 navigate('/home'); // Navigate to Home page for normal users
//               }
//             } else {
//               console.error('Error fetching user details:', response.statusText);
//             }
//           } catch (error) {
//             console.error('Error decoding JWT token:', error);
//           }
//         } else {
//           console.log('No JWT token found'); // Log if no JWT token is found
//         }
//       } else {
//         console.log('User is not logged in'); // Log when user is not logged in
//         setIsLoggedIn(false);
//         setIsAdmin(false);
//       }
//     });
  
//     return () => unsubscribe();
//   }, [navigate]);
  

//   const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
//   const handleCloseUserMenu = () => setAnchorElUser(null);

//   const handleLoginLogout = () => {
//     if (isLoggedIn) {
//       signOut(auth)
//         .then(() => {
//           setUserData({});
//           setIsLoggedIn(false);
//           navigate('/home');
//         })
//         .catch(console.error);
//     } else {
//       navigate('/login');
//     }
//   };

//   return (
//     <>
//       <AppBar position="static">
//         <Container maxWidth="xl">
//           <Toolbar disableGutters>
//             <img src="/ov--new.png" alt="Rete Logo" style={{ height: 70, marginRight: 10 }} />
//             <Typography
//               variant="h6"
//               noWrap
//               component={Link}
//               to="/"
//               sx={{
//                 mr: 2,
//                 fontFamily: 'monospace',
//                 fontWeight: 700,
//                 letterSpacing: '.1rem',
//                 color: 'inherit',
//                 textDecoration: 'none',
//               }}
//             >
//               Events
//             </Typography>
//             <Box sx={{ flexGrow: 1 }} />

//             <Box sx={{ mr: 2 }}>
//               <Tooltip title="Open settings">
//                 <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
//                   <Avatar alt={userData.displayName} src="/static/images/avatar/2.jpg" />
//                 </IconButton>
//               </Tooltip>
//               <Menu
//                 sx={{ mt: '45px' }}
//                 id="menu-appbar"
//                 anchorEl={anchorElUser}
//                 anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//                 keepMounted
//                 transformOrigin={{ vertical: 'top', horizontal: 'right' }}
//                 open={Boolean(anchorElUser)}
//                 onClose={handleCloseUserMenu}
//               >
//                 {settings.map((setting, index) => (
//                   <MenuItem key={index} onClick={handleLoginLogout}>
//                     <Typography textAlign="center">{isLoggedIn ? 'Logout' : 'Login'}</Typography>
//                   </MenuItem>
//                 ))}
//               </Menu>
//             </Box>
//           </Toolbar>
//         </Container>
//       </AppBar>
//     </>
//   );
// }

// export default Navbar;

import React, { useState, useEffect } from 'react'; // Import React and hooks for state management and lifecycle methods
import { AppBar, Toolbar, IconButton, Typography, Box, Tooltip, Avatar, Menu, MenuItem, Container } from '@mui/material'; // Import Material-UI components for UI styling and layout
import { Link, useNavigate } from 'react-router-dom'; // Import React Router components for navigation and links
import { onAuthStateChanged, signOut } from 'firebase/auth'; // Import Firebase auth methods to track auth state and sign out users
import { auth } from './firebase'; // Import the configured Firebase authentication instance
import { useLocation } from 'react-router-dom';

const settings = ['Login']; // Define menu settings, used in the user menu dropdown (will change to "Logout" if the user is logged in)

function Navbar() {
  // State to manage the anchor element for the user menu (for positioning)
  const [anchorElUser, setAnchorElUser] = useState(null);
  // State to track if a user is currently logged in
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  // State to determine if the current user is an admin
  const [isAdmin, setIsAdmin] = useState(false);
  // State to store user data such as display name and email
  const [userData, setUserData] = useState({});
  const navigate = useNavigate(); // Hook to programmatically navigate between pages
  const location = useLocation();

  useEffect(() => {

    // Set up an authentication state observer and retrieve user data on state change
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const { displayName, email } = user; // Destructure user properties to get display name and email
        setUserData({ displayName, email }); // Set user data in the state
        setIsLoggedIn(true); // Set logged-in status to true
        // Check if the logged-in user is an admin by matching their email with a predefined list in environment variables
        setIsAdmin(
          [process.env.REACT_APP_ADMIN_EMAIL1, process.env.REACT_APP_ADMIN_EMAIL2, process.env.REACT_APP_ADMIN_EMAIL3, process.env.REACT_APP_ADMIN_EMAIL4].includes(email)
        );

        // Navigate based on role (Admin or Normal User) after login
        console.log(location.pathname )
        if( location.pathname.toLowerCase().startsWith('/attendance') ){
          
        }
        else if ( [process.env.REACT_APP_ADMIN_EMAIL1, process.env.REACT_APP_ADMIN_EMAIL2, process.env.REACT_APP_ADMIN_EMAIL3, process.env.REACT_APP_ADMIN_EMAIL4].includes(email)) {
          navigate('/UploadEvent'); // Navigate to UploadEvent page for Admin
        } else {
          navigate('/home'); // Navigate to Home page for normal users
        }
      } else {
        setIsLoggedIn(false); // Set logged-in status to false if no user is logged in
        setIsAdmin(false); // Set admin status to false
      }
    });

    // Cleanup function to unsubscribe from the listener when the component unmounts
    return () => unsubscribe();
  }, [navigate]); // Dependency array includes navigate, ensuring the effect is re-run if the navigate reference changes

  // Handle the event of opening the user menu by setting the anchor element
  const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
  // Close the user menu by setting the anchor element to null
  const handleCloseUserMenu = () => setAnchorElUser(null);

  // Function to handle login or logout based on the current authentication state
  const handleLoginLogout = () => {
    if (isLoggedIn) {
      signOut(auth) // Firebase function to log out the user
        .then(() => {
          setUserData({}); // Clear user data on successful logout
          setIsLoggedIn(false); // Update the logged-in state
          navigate('/home'); // Redirect to home page after logout
        })
        .catch(console.error); // Log any errors that occur during the sign-out process
    } else {
      navigate('/login'); // Redirect to the login page if the user is not logged in
    }
  };

  return (
    <>
      <AppBar position="static"> {/* Define a static AppBar at the top of the page */}
        <Container maxWidth="xl"> {/* Container to control the width of the AppBar */}
          <Toolbar disableGutters> {/* Toolbar to arrange content horizontally */}
            {/* Rete Logo */}
            <img src="/ov--new.png" alt="Rete Logo" style={{ height: 70, marginRight: 10 }} />
            {/* Application Title */}
            <Typography
              variant="h6"
              noWrap
              component={Link} // Link component from React Router to handle navigation
              to="/" // Navigate to home page when clicked
              sx={{
                mr: 2,
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.1rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              Events
            </Typography>
            <Box sx={{ flexGrow: 1 }} /> {/* Empty box to push menu items to the right */}

            <Box sx={{ mr: 2 }}> {/* Box for styling the user avatar and menu */}
              <Tooltip title="Open settings"> {/* Tooltip on the Avatar */}
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}> {/* Button to open user menu */}
                  {/* Display user avatar or default avatar */}
                  <Avatar alt={userData.displayName} src="/static/images/avatar/2.jpg" />
                </IconButton>
              </Tooltip>
              {/* User menu for login/logout */}
              <Menu
                sx={{ mt: '45px' }} // Style for menu margin-top
                id="menu-appbar"
                anchorEl={anchorElUser} // Bind the menu to the anchor element
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Define where the menu originates from
                keepMounted // Keep the menu mounted even when closed
                transformOrigin={{ vertical: 'top', horizontal: 'right' }} // Define where the menu transforms from
                open={Boolean(anchorElUser)} // Open the menu when anchorElUser is not null
                onClose={handleCloseUserMenu} // Close the menu when requested
              >
                {/* Map through the settings array and render each setting in the menu */}
                {settings.map((setting, index) => (
                  <MenuItem key={index} onClick={handleLoginLogout}> {/* Call handleLoginLogout on click */}
                    {/* Display 'Login' or 'Logout' based on current user state */}
                    <Typography textAlign="center">{isLoggedIn ? 'Logout' : 'Login'}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
}

export default Navbar;

